// extracted by mini-css-extract-plugin
export default {"inline":"TaskResponsible_inline__ia1Oz","task_responsible":"TaskResponsible_task_responsible__B9h+G"};